import Vue from 'vue'
import Router from 'vue-router'

import login from './views/login'
import home from './views/home'
import warn from './views/warn'
import mine from './views/mine'
import help from './views/help'
import helpList from './views/helpList'
import noticeList from './views/noticeList'
import helpDetail from './views/helpDetail'
import projectList from './views/projectList'
import projectDetail from './views/projectDetail'
import search from './views/search'
import searchAll from './views/searchAll'
import statistics from './views/statistics'
import deviceList from './views/deviceList'
import chargeList from './views/chargeList'
import chargeDetail from './views/chargeDetail'
import historyChargeList from './views/historyChargeList'
import warnDetail from './views/warnDetail'
import repairDetail from './views/repairDetail'
import deviceDetail from './views/deviceDetail'//设备详情
import contacts from './views/contacts'
import cpsc from './views/cpsc'
import khInfo from './views/khInfo'
import khList from './views/khList'
import changephone from './views/changephone'
//表具管理
import meterList from './views/meterManage/meterList'
import uploadDegree from './views/meterManage/uploadDegree'
import addMeter from './views/meterManage/addMeter' 
import uploadBill from './views/meterManage/uploadBill'
import payDetail from './views/meterManage/payDetail' 
import uploadResult from './views/meterManage/uploadResult' 
import qrInfo from './views/qrInfo' // 扫码详情-选择设备
import chargeRule from './views/chargeRule' //计费规则 
import newDeviceActiveResult from './views/newDeviceActiveResult' //新设备激活完成 
import uploadCardBill from './views/meterManage/uploadCardBill' //上传物联网卡缴费凭证
import rechargeList from './views/recharge/rechargeList' //充值列表
import rechargeDetail from './views/recharge/rechargeDetail' //充值详情
import refundSuccess from './views/recharge/success'
import refundList from './views/refund/refundList'
import refundDetail from './views/refund/refundDetail'

//施工管理
import constructionList from './views/construction/constructionList'
import constructionDeviceList from './views/construction/constructionDeviceList'
import constructionDetail from './views/construction/constructionDetail'
import createDevice from './views/construction/createDevice'
import createProject from './views/construction/createProject'

//卡片管理
import cardManageList from './views/cardManage/cardManageList'
import cardManageDetail from './views/cardManage/cardManageDetail'

//虚拟充值
import virtualRecharge from './views/virtualRecharge'

Vue.use(Router)

const routes = [
  {
    path: '/login.html',
    name: 'login',
    meta:{index:0},
    component: login,
  },
  {
    path: '/home.html',
    name: 'home',
    meta:{index:1},
    component: home,
  },
  {
    path: '/warn.html',
    name: 'warn',
    meta:{index:2,
      keepAlive: true,
    },
    component: warn,
  },
  {
    path: '/mine.html',
    name: 'mine',
    meta:{index:3},
    component: mine,
  },
  {
    path: '/help.html',
    name: 'help',
    meta:{index:4},
    component: help,
  },
  {
    path: '/helpList.html',
    name: 'helpList',
    meta:{index:5},
    component: helpList,
  },
  {
    path: '/noticeList.html',
    name: 'noticeList',
    meta:{index:32,keepAlive: true},
    component: noticeList,
  },
  {
    path: '/helpDetail.html',
    name: 'helpDetail',
    meta:{index:6},
    component: helpDetail,
  },
  {
    path: '/deviceDetail.html',
    name: 'deviceDetail',
    component: deviceDetail,
  },
  {
    path: '/projectList.html',
    name: 'projectList',
    meta:{index:7},
    component: projectList,
  },
  {
    path: '/projectDetail.html',
    name: 'projectDetail',
    meta:{index:7},
    component: projectDetail,
  },
  {
    path: '/search.html',
    name: 'search',
    meta:{index:8},
    component: search,
  },
  {
    path: '/searchAll.html',
    name: 'searchAll',

    meta:{
      index:8,
      keepAlive: true, //true为需要缓存，false为不需要缓存（不需要的也可以不加）
    },
    component: searchAll,
  },
  {
    path: '/statistics.html',
    name: 'statistics',
    meta:{index:9},
    component: statistics,
  },
  {
    path: '/deviceList.html',
    name: 'deviceList',
    meta:{index:10},
    component: deviceList,
  },
  {
    path: '/chargeList.html',
    name: 'chargeList',
    meta:{index:11},
    component: chargeList,
  },
  {
    path: '/chargeDetail.html',
    name: 'chargeDetail',
    meta:{index:13},
    component: chargeDetail,
  },
  {
    path: '/historyChargeList.html',
    name: 'historyChargeList',
    meta:{index:11},
    component: historyChargeList,
  },
  {
    path: '/warnDetail.html',
    name: 'warnDetail',
    meta:{index:14},
    component: warnDetail,
  },
  {
    path: '/repairDetail.html',
    name: 'repairDetail',
    component: repairDetail,
  },
  {
    path: '/contacts.html',
    name: 'contacts',
    meta:{index:15},
    component: contacts,
  },
  {
    path: '/cpsc.html',
    name: 'cpsc',
    meta:{index:16},
    component: cpsc,
  },
  {
    path: '/qrInfo.html',
    name: 'qrInfo',
    meta:{index:17},
    component: qrInfo,
  },
  {
    path: '/newDeviceActiveResult.html',
    name: 'newDeviceActiveResult',
    meta:{},
    component: newDeviceActiveResult,
  },  
  {
    path: '/khInfo.html',
    name: 'khInfo',
    meta:{index:18},
    component: khInfo,
  },
  {
    path: '/khList.html',
    name: 'khList',
    meta:{index:18},
    component: khList,
  },
  {
    path: '/meterList.html',
    name: 'meterList',
    meta:{index:19},
    component: meterList,
  },
  {
    path: '/uploadDegree.html',
    name: 'uploadDegree',
    meta:{index:20},
    component: uploadDegree,
  },
  {
    path: '/addMeter.html',
    name: 'addMeter',
    meta:{index:21},
    component: addMeter,
  },
  {
    path: '/uploadBill.html',
    name: 'uploadBill',
    meta:{index:22},
    component: uploadBill,
  },
  {
    path: '/payDetail.html',
    name: 'payDetail',
    meta:{index:23},
    component: payDetail,
  },
  {
    path: '/uploadResult.html',
    name: 'uploadResult',
    meta:{index:24},
    component: uploadResult,
  },
  {
    path: '/chargeRule.html',
    name: 'chargeRule',
    meta:{index:25},
    component: chargeRule,
  },
  {
    path: '/uploadCardBill.html',
    name: 'uploadCardBill',
    meta:{index:26},
    component: uploadCardBill,
  },
  {
    path: '/changephone.html',
    name: 'changephone',
    meta:{index:27},
    component: changephone,
  },
  {
    path: '/rechargeList.html',
    name: 'rechargeList',
    meta:{
      index:27,
      keepAlive: true, //true为需要缓存，false为不需要缓存（不需要的也可以不加）
    },
    component: rechargeList,
  },
  {
    path: '/rechargeDetail.html',
    name: 'rechargeDetail',
    meta:{index:28},
    component: rechargeDetail,
  },
  {
    path: '/refundSuccess.html',
    name: 'refundSuccess',
    meta:{index:29},
    component: refundSuccess,
  },
  {
    path: '/refundList.html',
    name: 'refundList',
    meta:{
      index:30,
      keepAlive: true,
    },
    component: refundList,
  },
  {
    path: '/refundDetail.html',
    name: 'refundDetail',
    meta:{index:31},
    component: refundDetail,
  },
  //施工管理
  {
    path: '/constructionList.html',
    name: 'constructionList',
    meta:{index:33},
    component: constructionList,
  },
  {
    path: '/constructionDeviceList.html',
    name: 'constructionDeviceList',
    meta:{index:34},
    component: constructionDeviceList,
  },
  {
    path: '/constructionDetail.html',
    name: 'constructionDetail',
    meta:{},
    component: constructionDetail,
  },
  {
    path: '/createDevice.html',
    name: 'createDevice',
    meta:{},
    component: createDevice,
  },
  {
    path: '/createProject.html',
    name: 'createProject',
    meta:{},
    component: createProject,
  },
  {
    path: '/cardManageList.html',
    name: 'cardManageList',
    meta:{index:35},
    component: cardManageList,
  },
  {
    path: '/cardManageDetail.html',
    name: 'cardManageDetail',
    meta:{},
    component: cardManageDetail,
  },
  {
    path: '/virtualRecharge.html',
    name: 'virtualRecharge',
    meta:{},
    component: virtualRecharge,
  },
  
  // {
  //   path: '*',
  //   redirect: '/home.html',
  // }
]
const router = new Router({
  base: '/ild',
  mode: 'history',
  routes: routes
})
export default router

// router.beforeEach((to, from, next) => {
   
// })




